import * as React from 'react';
import { MediaContext } from '..';
import { VideoControlAreaContext } from '../video';
import { styled } from '../../theme-provider';
const ANIMATION_FUNCTION = 'cubic-bezier(0.14, 1.12, 0.67, 0.99)';
const StyledControlContainer = styled.div.withConfig({ displayName: "StyledControlContainer", componentId: "sc-1e60bjj" }) `display:flex;align-items:center;gap:${(props) => props.theme.size.static300};width:100%;height:60px;padding:0 ${(props) => props.theme.size.static350};background:${(props) => props.theme.colors.overlay.default};transition:${({ visible }) => visible
    ? `opacity 0.5s ${ANIMATION_FUNCTION}`
    : `opacity 0.5s 0.3s ${ANIMATION_FUNCTION}`};opacity:${({ visible }) => !visible && '0'};pointer-events:${({ visible }) => !visible && 'none'};`;
export const ControlContainer = (props) => {
    const mediaElement = React.useContext(MediaContext);
    const videoControlAreaElement = React.useContext(VideoControlAreaContext);
    const [isPlaying, setIsPlaying] = React.useState(false);
    const [isPlayed, setIsPlayed] = React.useState(false);
    const [isHovering, setIsHovering] = React.useState(false);
    const timeoutId = React.useRef();
    const handlePlay = React.useCallback(() => {
        setIsPlaying(true);
        setIsPlayed(true);
    }, []);
    const handlePause = React.useCallback(() => {
        setIsPlaying(false);
    }, []);
    const handleEnded = React.useCallback(() => {
        setIsPlayed(false);
    }, []);
    const handleInteraction = React.useCallback(() => {
        setIsHovering(true);
        timeoutId.current && clearTimeout(timeoutId.current);
        timeoutId.current = window.setTimeout(() => {
            setIsHovering(false);
        }, 2000);
    }, []);
    React.useEffect(() => {
        return () => {
            if (timeoutId.current)
                clearTimeout(timeoutId.current);
        };
    }, [timeoutId]);
    React.useEffect(() => {
        mediaElement === null || mediaElement === void 0 ? void 0 : mediaElement.addEventListener('play', handlePlay);
        mediaElement === null || mediaElement === void 0 ? void 0 : mediaElement.addEventListener('pause', handlePause);
        mediaElement === null || mediaElement === void 0 ? void 0 : mediaElement.addEventListener('ended', handleEnded);
        videoControlAreaElement === null || videoControlAreaElement === void 0 ? void 0 : videoControlAreaElement.addEventListener('mousemove', handleInteraction);
        videoControlAreaElement === null || videoControlAreaElement === void 0 ? void 0 : videoControlAreaElement.addEventListener('touchmove', handleInteraction);
        videoControlAreaElement === null || videoControlAreaElement === void 0 ? void 0 : videoControlAreaElement.addEventListener('focus', handleInteraction, true);
        return () => {
            mediaElement === null || mediaElement === void 0 ? void 0 : mediaElement.removeEventListener('play', handlePlay);
            mediaElement === null || mediaElement === void 0 ? void 0 : mediaElement.removeEventListener('pause', handlePause);
            mediaElement === null || mediaElement === void 0 ? void 0 : mediaElement.removeEventListener('ended', handleEnded);
            videoControlAreaElement === null || videoControlAreaElement === void 0 ? void 0 : videoControlAreaElement.removeEventListener('mousemove', handleInteraction);
            videoControlAreaElement === null || videoControlAreaElement === void 0 ? void 0 : videoControlAreaElement.removeEventListener('touchmove', handleInteraction);
            videoControlAreaElement === null || videoControlAreaElement === void 0 ? void 0 : videoControlAreaElement.removeEventListener('focus', handleInteraction, true);
        };
    }, [
        handleEnded,
        handleInteraction,
        handlePause,
        handlePlay,
        mediaElement,
        videoControlAreaElement,
    ]);
    const visible = (!isPlaying || isHovering) && (!props.hideInitially || isPlayed);
    return (React.createElement(StyledControlContainer, { visible: visible }, props.children));
};
ControlContainer.displayName = 'ControlContainer';
